import { DefaultError, QueryClient, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { useLocalStorage } from "~/Hooks/useLocalStorage";
import { passengerCMSApi } from "~/Services";

interface DocumentDetailsResponse {
  id: string;
  title: string;
  field_page_banner_image: string;
  field_page_title_en: string;
  field_page_title_ms: string;
  field_page_title_zh: string;
  field_page_description_en: string;
  field_page_description_ms: string;
  field_page_description_zh: string;
}

const fetchMapHeadingDetails = async (airport: string | null): Promise<DocumentDetailsResponse> => {
  if (!airport) throw new Error("Airport not found");
  const response = await passengerCMSApi.get(`/api/page-headers/all-fields?pageName=map&airport=${airport}`);
  console.log(response.data[0], "tested");
  return response.data[0];
};

const useMapHeadingDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  const [currentAirport] = useLocalStorage("currentAirport", null);
  return useQuery<DocumentDetailsResponse, DefaultError>(
    {
      queryKey: ["MapHeadingDocumentDetails", id, currentAirport],
      enabled: !!id && !!currentAirport,
      queryFn: () => fetchMapHeadingDetails(currentAirport),
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useMapHeadingDocumentDetails };
